import { LazyBootModule } from 'owa-bundling-light';
import { createLazyComponent, LazyImport } from 'owa-bundling';
import CommandRibbonPlaceholder from 'owa-command-ribbon/lib/components/CommandRibbonPlaceholder';

const LazyCalendarRibbonModule = new LazyBootModule(
    () => import(/* webpackChunkName: "CalendarRibbon" */ './lazyIndex')
);

export let LazyCalendarRibbon = createLazyComponent(
    LazyCalendarRibbonModule,
    m => m.CalendarRibbon,
    CommandRibbonPlaceholder
);

export const LazyCalendarRibbonImport = new LazyImport(
    LazyCalendarRibbonModule,
    m => m.CalendarRibbon
);
